import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/utils/fonts.ts\",\"import\":\"Sen\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"variable\":\"--font-family-sen\",\"display\":\"swap\"}],\"variableName\":\"sen\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/utils/fonts.ts\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"cyrillic\",\"cyrillic-ext\",\"devanagari\",\"greek\",\"greek-ext\",\"latin\",\"latin-ext\",\"vietnamese\"],\"variable\":\"--font-family-noto\",\"display\":\"swap\"}],\"variableName\":\"noto\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/utils/fonts.ts\",\"import\":\"Be_Vietnam_Pro\",\"arguments\":[{\"subsets\":[\"vietnamese\"],\"display\":\"swap\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-vietnam\"}],\"variableName\":\"bVietnamPro\"}");
;
import(/* webpackMode: "eager", webpackExports: ["fetchAutocompleteResults"] */ "/app/src/app/api/search.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CurrencySelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FooterNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/LanguageAndCurrencyMobile/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
